/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    textContainer: "text-container",
    fullName: "full-name",
    username: "username",
    button: "button",
};
//# sourceMappingURL=resources.js.map
